module.exports = __webpack_public_path__ + "static/media/WctCardImg2.a145d983.png";